import React, { ReactNode } from 'react';
import ActionButton from './ActionButton';
import { NavLink } from 'react-router-dom';

type Props = {
    icon: ReactNode,
    className?: string,
    label?: string,
    to: string
}

const NavigationButton = (props:Props) => {
    return (
        <NavLink to={props.to} >
            <ActionButton  icon={props.icon} label={props.label} className={ props.className }/>
        </NavLink>
    )
}

export default NavigationButton;